interface ExternalLinkProps {
    color?: string;
    className?: string;
}

function ExternalLink({ color = 'currentColor', className = null }: ExternalLinkProps) {
    return (
        <svg
            width="29"
            height="23"
            viewBox="0 0 29 23"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M13.6993 2.22266H6.30246C5.27678 2.22266 4.44531 3.25738 4.44531 4.53377V17.6893C4.44531 18.9657 5.27678 20.0004 6.30246 20.0004H13.6993C14.725 20.0004 15.5564 18.9657 15.5564 17.6893V4.53377C15.5564 3.25738 14.725 2.22266 13.6993 2.22266Z"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.1094 11.1113H25.5069"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M20.7207 5.17773L26.6632 11.1111L20.7207 17.0444"
                stroke={color}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

export default ExternalLink;
